
import DB from './DB'

const LOG_MIN_CHUNK = 5
const LOG_MAX_CHUNK = 100
const LOG_INTERVAL = 300 // 5 minutes expressed in seconds

export default {
  mixins: [
    DB,
  ],

  data: () => ({
    logTimer: undefined,
  }),

  methods: {
    async getLogKeyRange () {
      const lowerKey = await this.db.getAllKeys('logs', null, 1)
      let count = await this.countLogs()
      if (count > LOG_MAX_CHUNK) {
        count = LOG_MAX_CHUNK
      }
      return lowerKey?.length === 1
        ? IDBKeyRange.upperBound(lowerKey[0] + count, true)
        : 0
    },
    async getLogs (keyRange = null) {
      return await this.db.getAll('logs', keyRange)
    },
    async countLogs (keyRange = null) {
      return await this.db.count('logs', keyRange)
    },
    async deleteLogs (keyRange) {
      return await this.db.delete('logs', keyRange)
    },
    async sendLog () {
      if ('serviceWorker' in navigator && 'SyncManager' in window) {
        navigator.serviceWorker.ready
          .then(reg => reg.sync.register('sendLog').then(() => this.queueSendLog()))
          .catch(err => this.sendLogFromSpa(true))
      } else {
        this.sendLogFromSpa(true)
      }
    },
    async sendLogFromSpa (queue = false) {
      const keyRange = await this.getLogKeyRange()
      const logs = await this.getLogs(keyRange)

      if (! Array.isArray(logs) || ! logs.length) {
        return
      }

      this.$api('actionLog', logs)
        .then(async r => {
          await this.deleteLogs(keyRange)
          if (queue) {
            const remaining = await this.countLogs()
            const wait = remaining >= LOG_MIN_CHUNK ? 50 : null
            this.queueSendLog(wait)
          }
        })
       .catch(e => console.warn(e))
    },
    queueSendLog (wait) {
      this.logTimer = setTimeout(() => this.sendLog(), wait ?? LOG_INTERVAL * 1000)
    },
    stopSendLog () {
      clearTimeout(this.logTimer)
    },
  },
}
